var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodeoButtonActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02395 28.5475L6.02207 28.5436C4.55176 25.4458 4.92662 22.083 6.06638 18.7396C6.9028 16.286 8.09886 13.973 9.19337 11.8563C9.60529 11.0597 10.0028 10.2909 10.3614 9.55292C11.5055 7.22202 13.2973 6.14125 15.1412 5.82839C17.0295 5.50798 19.0018 5.99214 20.3939 6.87164C20.5105 6.9453 20.6297 7.02084 20.7515 7.09799C23.8867 9.08488 28.7126 12.1432 34.4202 11.8183C36.505 11.6997 38.5128 11.1807 40.4925 10.669C41.2549 10.472 42.0131 10.276 42.77 10.1044C45.5515 9.47362 48.5896 9.08033 52.4727 9.82287C54.5878 10.2273 56.0675 10.9551 57.3228 12.1388C58.6077 13.3505 59.715 15.0925 60.9835 17.642C62.0102 19.7058 62.9896 22.0799 63.6639 24.3525C64.3451 26.6482 64.6851 28.7432 64.5179 30.2884C64.357 31.7752 63.6876 33.0979 62.4382 34.7591C61.6653 35.7867 60.7264 36.8761 59.6057 38.1764C58.8708 39.029 58.0578 39.9723 57.1622 41.0483C54.9302 43.7298 53.9802 46.9766 53.1028 49.9753C53.0489 50.1595 52.9953 50.3427 52.9417 50.5248C51.9932 53.746 51.0383 56.65 48.767 58.8792C45.9284 61.665 41.8076 62.8481 37.7071 62.9366C33.5987 63.0253 29.7009 62.0099 27.432 60.6202C25.3663 59.355 24.1518 57.2389 22.9681 54.3704C22.6372 53.5686 22.3081 52.7046 21.9619 51.7958C21.1009 49.5351 20.1342 46.9973 18.7718 44.45C16.861 40.8774 14.4378 38.5248 12.1764 36.3293C12.1142 36.2689 12.0521 36.2086 11.9902 36.1485C9.6659 33.8906 7.53713 31.7722 6.02395 28.5475Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.625 26.251H41.75V29.376",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3748 42.75H31.2498V39.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.75 39.625V42.75H38.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2498 29.376V26.251H34.3748",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodeoButtonActive);
export default __webpack_public_path__ + "static/media/rodeo-button-active.fef9cc6161b7b0d765c2dfe76b12b2a5.svg";
export { ForwardRef as ReactComponent };